// @flow

import type { Endpoints, EntityFieldCollection, SortParams } from '../types';
import { createdAtField, idField } from '../abstract/StoredEntity';
import type { StoredEntity } from '../abstract/StoredEntity';
import { constructEndpoints } from '../helpers';
import Admin from './Admin';
import OrganizationUser from './OrganizationUser';
import Organization from './Organization';
import { DescendingSortOrder } from '../types';

class OrgUserRT implements StoredEntity {
    static classInternalName = 'org_user_rt';

    static fields: EntityFieldCollection = {
        id: idField,
        createdAt: createdAtField,
        expiration: {
            displayName: 'Expiration',
            recordName: 'expiration',
            dataType: {
                primitive: 'ts',
                isArray: false,
                extraData: null,
            },
            supportsQuery: true,
            supportsSort: true,
            needToCreate: true,
            canEdit: true,
            isOptional: false,
            displayOnMain: true,
        },
        issuerId: {
            displayName: 'Issuer',
            recordName: 'issuer_id',
            dataType: {
                primitive: 'ref',
                isArray: false,
                extraData: {
                    model: () => Admin,
                    maxValues: 1,
                },
            },
            supportsQuery: true,
            supportsSort: false,
            needToCreate: false,
            canEdit: false,
            isOptional: false,
            displayOnMain: true,
        },
        userId: {
            displayName: 'User',
            recordName: 'user_id',
            dataType: {
                primitive: 'ref',
                isArray: false,
                extraData: {
                    model: () => OrganizationUser,
                    maxValues: 1,
                },
            },
            supportsQuery: true,
            supportsSort: false,
            needToCreate: false,
            canEdit: false,
            isOptional: true,
            displayOnMain: true,
        },
        organizationId: {
            displayName: 'Organization',
            recordName: 'organization_id',
            dataType: {
                primitive: 'ref',
                isArray: false,
                extraData: {
                    model: () => Organization,
                    maxValues: 1,
                },
            },
            supportsQuery: true,
            supportsSort: false,
            needToCreate: true,
            canEdit: true,
            isOptional: true,
            displayOnMain: true,
        },
        role: {
            displayName: 'Role',
            recordName: 'role',
            dataType: {
                primitive: 'enum',
                isArray: false,
                extraData: {
                    1: 'Staff',
                    2: 'Admin',
                },
            },
            supportsQuery: true,
            supportsSort: true,
            needToCreate: true,
            canEdit: true,
            isOptional: false,
            displayOnMain: true,
        },
        enabled: {
            displayName: 'Enabled',
            recordName: 'enabled',
            dataType: {
                primitive: 'bool',
                isArray: false,
                extraData: null,
            },
            supportsQuery: true,
            supportsSort: true,
            needToCreate: true,
            canEdit: true,
            isOptional: false,
            displayOnMain: true,
        },
    };

    static fileFields: EntityFieldCollection = {};

    static defaultSort: SortParams = {
        field: OrgUserRT.fields.expiration,
        fieldName: 'expiration',
        order: DescendingSortOrder,
    };

    get id() {
        return this.record[OrgUserRT.fields.id.recordName];
    }

    get displayName() {
        return this.record[OrgUserRT.fields.id.recordName];
    }

    static endpoints: Endpoints = constructEndpoints('org-user-rts');

    constructor(record: any) {
        this.record = record;
    }
}

export default OrgUserRT;
